// src/Store/patientSearchSlice.js (CORRECTED)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';

const LABS_API_BASE_URL = BaseUrl.labsurl

// --- SEARCH THUNKS (Existing) ---

export const searchServices = createAsyncThunk(
  'patientSearch/searchServices',
  async (searchTerm, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${LABS_API_BASE_URL}PatientServices/GetServicesByMRNPhoneName?Val=${searchTerm}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const searchPackages = createAsyncThunk(
  'patientSearch/searchPackages',
  async (searchTerm, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${LABS_API_BASE_URL}PatientPackages/GetPackagesByMRNPhoneName?Val=${searchTerm}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// --- MASTER DATA THUNKS (NEW) ---

export const getLabTestServiceMasterData = createAsyncThunk(
  'patientSearch/getLabTestServiceMasterData',
  async (serviceId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${LABS_API_BASE_URL}LabTestServices/${serviceId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPackageServicesMasterData = createAsyncThunk(
  'patientSearch/getPackageServicesMasterData',
  async (packageId, { rejectWithValue }) => {
    try {
      // NOTE: Assumes API supports filtering by query param: /api/PackageServices?packageId={id}
      const response = await axios.get(
        `${LABS_API_BASE_URL}PackageServices` 
      );
      const services = response.data
      return services;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchPackageServicesMaster = createAsyncThunk(
    'labTestUpdates/fetchPackageServicesMaster',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const url = `${laburl}PackageServices`;
            const response = await axios.get(url, { headers: headers }); 
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch package services master data');
        }
    }
);
// --- SLICE SETUP ---

const initialState = {
  searchedServices: [],
  searchedPackages: [],
  loading: 'idle', 
  error: null,
  activeTab: 'services', 
  
  serviceMasterData: null,
  packageServicesMasterData: [],
  masterDataLoading: 'idle',
  masterDataError: null,
  packageServicesMaster: [],
    loadingPackageServicesMaster: false,
    errorPackageServicesMaster: null,
};

const patientSearchSlice = createSlice({
  name: 'patientSearch',
  initialState,
  reducers: {
    setSearchActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    clearSearchResults: (state) => {
      state.searchedServices = [];
      state.searchedPackages = [];
      state.loading = 'idle';
      state.error = null;
    },
    clearMasterData: (state) => {
      state.serviceMasterData = null;
      state.packageServicesMasterData = [];
      state.masterDataLoading = 'idle';
      state.masterDataError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 1. --- All Specific addCase calls (MUST COME FIRST) ---

      // Search Fulfilled
      .addCase(searchServices.fulfilled, (state, action) => {
        state.searchedServices = action.payload;
      })
      .addCase(searchPackages.fulfilled, (state, action) => {
        state.searchedPackages = action.payload;
        state.loading = 'succeeded'; // Set succeeded after the second search completes
      })
      
      .addCase(getLabTestServiceMasterData.fulfilled, (state, action) => {
        state.serviceMasterData = action.payload;
        state.masterDataLoading = 'succeeded';
      })
      .addCase(getLabTestServiceMasterData.rejected, (state, action) => {
        state.masterDataError = action.payload;
        state.masterDataLoading = 'failed';
      })
      .addCase(getPackageServicesMasterData.fulfilled, (state, action) => {
        state.packageServicesMasterData = action.payload;
        state.masterDataLoading = 'succeeded';
      })
      .addCase(getPackageServicesMasterData.rejected, (state, action) => {
        state.masterDataError = action.payload;
        state.masterDataLoading = 'failed';
      })
  .addCase(fetchPackageServicesMaster.pending, (state) => {
                state.loadingPackageServicesMaster = true;
            })
            .addCase(fetchPackageServicesMaster.fulfilled, (state, action) => {
                state.loadingPackageServicesMaster = false;
                state.packageServicesMaster = action.payload;
            })
            .addCase(fetchPackageServicesMaster.rejected, (state, action) => {
                state.loadingPackageServicesMaster = false;
                state.errorPackageServicesMaster = action.payload || action.error.message;
            })
      // 2. --- All Generic addMatcher calls (MUST COME SECOND) ---

      // Search Pending/Rejected Matchers
      .addMatcher(
        (action) => action.type.endsWith('/pending') && (action.type.includes('searchServices') || action.type.includes('searchPackages')),
        (state) => {
          state.loading = 'pending';
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected') && (action.type.includes('searchServices') || action.type.includes('searchPackages')),
        (state, action) => {
          state.error = action.payload;
          state.loading = 'failed';
        }
      )

      // Master Data Pending Matcher
      .addMatcher(
        (action) => action.type.endsWith('/pending') && (action.type.includes('getLabTestServiceMasterData') || action.type.includes('getPackageServicesMasterData')),
        (state) => {
          state.masterDataLoading = 'pending';
          state.masterDataError = null;
          state.serviceMasterData = null;
          state.packageServicesMasterData = [];
        }
      );
  },
});

export const { setSearchActiveTab, clearSearchResults, clearMasterData } = patientSearchSlice.actions;

export default patientSearchSlice.reducer;